import { dispatch } from './stateManager';
import {
  StackPageAction,
  StackPageComponent,
  StackPageFunctionName,
  StackPageOptions,
} from './types';

const getStackPageFunctions = (
  dispatch: (action: StackPageAction) => void
) => ({
  [StackPageFunctionName.POP_STACK_PAGE_BY_ID]: (id: string) => {
    dispatch({
      type: StackPageFunctionName.POP_STACK_PAGE_BY_ID,
      id,
    });
  },
  [StackPageFunctionName.POP_STACK_PAGE_BY_NAME]: (stackPageName: string) => {
    dispatch({
      type: StackPageFunctionName.POP_STACK_PAGE_BY_NAME,
      stackPageName,
    });
  },
  [StackPageFunctionName.PUSH_STACK_PAGE]: (
    page: StackPageComponent,
    options: StackPageOptions = {}
  ) => {
    dispatch({
      type: StackPageFunctionName.PUSH_STACK_PAGE,
      page,
      options,
    });
  },
});

const stackPageFunctions = getStackPageFunctions(dispatch);

/**
 * @deprecated Avoid this in new code. Render `AnimatedModal` from
 * `@ardoq/modal` or `AnimatedBottomDrawer` from `@ardoq/drawer` and control
 * `isOpen` like any other state.
 */
export const popStackPageById = stackPageFunctions.popStackPageById;

/**
 * @deprecated Avoid this in new code. Render `AnimatedModal` from
 * `@ardoq/modal` or `AnimatedBottomDrawer` from `@ardoq/drawer` and control
 * `isOpen` like any other state.
 */
export const popStackPageByName = stackPageFunctions.popStackPageByName;

/**
 * @deprecated Avoid this in new code. Render `AnimatedModal` from
 * `@ardoq/modal` or `AnimatedBottomDrawer` from `@ardoq/drawer` and control
 * `isOpen` like any other state.
 */
export const pushStackPage = stackPageFunctions.pushStackPage;
